import {
  EVENT_CALL_STARTED,
  EventCallStartedPayload,
} from '@weblite/ts-action/media-proxy'
import { getRoom } from '$logic/room'
import { CallWappPanel } from '$logic/wapp-panels'
import { closePvCallManager } from '$logic/router'
import { callStorage } from './storage'
import { dateWithOffset } from '$logic/client-device/time-offset.service'
import { serverSub } from '$func/subscription'
import { callServersConfig } from '$logic/call/service'

serverSub.subscribe(
  EVENT_CALL_STARTED,
  async ({ roomId, callType, token }: EventCallStartedPayload) => {
    const { roomId: pvCallRoomId } = callStorage.getPvMeta()
    if (roomId !== pvCallRoomId) return

    if (callType === 'call') {
      callStorage.set({
        roomId: roomId,
        callType: 'call',
        joinedAt: new Date().getTime(),
      })

      callStorage.resetPvMeta()
      closePvCallManager()

      const roomCall = (await getRoom(roomId))?.call
      CallWappPanel.openCall(callType, token!, {
        startedAt: roomCall?.startedAt ?? dateWithOffset(),
        ...callServersConfig,
      })
    }
  },
)
